import { render, staticRenderFns } from "./GeodesiaAcknowledgmentSection.vue?vue&type=template&id=e9521b6c&scoped=true"
import script from "./GeodesiaAcknowledgmentSection.vue?vue&type=script&lang=js"
export * from "./GeodesiaAcknowledgmentSection.vue?vue&type=script&lang=js"
import style0 from "./GeodesiaAcknowledgmentSection.vue?vue&type=style&index=0&id=e9521b6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9521b6c",
  null
  
)

export default component.exports